import styled from "styled-components";

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #D8DCDE;
  background-color: white;
  flex-grow: 1; 
  overflow: hidden; 
`;

export const ContainerTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #D8DCDE;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ContainerType = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;

  p {
    color: #373A3E;
    font-size: 14px;
  }
  span {
    background-color: #2F5BFF;
    color: white;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
  }
`;

export const CommentTypeSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    font-size: 13px;
    color: #373A3E;
    font-weight: 500;
  }
`;

export const CommentTypeToggle = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props => props.$active ? '#E8F5E9' : '#F5F5F5'};
  border: 1px solid ${props => props.$active ? '#2F5BFF' : '#D8DCDE'};

  &:hover {
    background-color: ${props => props.$active ? '#C8E6C9' : '#EEEEEE'};
  }

  span {
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.$active ? '#2F5BFF' : '#616161'};
  }
`;

export const ContainerTable = styled.div`
  flex: 1;                
  padding: 16px 24px;
  width: 100%;
  overflow: hidden;       

  &.noContent {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.noContent p {
    color: #9A9FA2;
    font-size: 14px;
    text-align: center;
  }
`;

export const TableScrollWrapper = styled.div`
  width: 100%;
  height: 100%;

  overflow-x: auto;
  overflow-y: auto;

  table {
    min-width: max-content;
    border-spacing: 0;
  }
`;

export const ErrorBannerLarge = styled.div`
  background: #fff5f5;
  border: 2px solid #cc0000;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  color: #cc0000;
`;

export const ErrorBannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ErrorBannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorBannerTitle = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #cc0000;
`;

export const ErrorBannerSubtitle = styled.span`
  font-size: 14px;
  color: #666;
`;